import { WaterRemoveOutlineIcon } from './WaterRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id C90739A3-CEDE-4524-A736-BA5A5B5F0CCB
 * name water-remove-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-remove-outline.svg
 * tags
 */
export const InkRemoveOutlineIcon = WaterRemoveOutlineIcon;
export default InkRemoveOutlineIcon